<template>
  <transition name="modal" appear>
    <div class="modal-overlay" @click.self="closeModal">
      <div class="modal-content payment-modal-content">
        <div class="logintop-head payment-head">
          <p>Complete payment</p>
          <img src="/images/logo.png" alt="SYNAPSE">
        </div>

        <p class="payment-subtitle">Pay securely with Polar to finish signup</p>

        <div v-if="plan" class="selected-plan-wrap">
          <div class="membership-pill" :class="plan.toneClass">
            <div class="membership-pill-body">
              <h4>
                <img :src="plan.image" :alt="plan.title" />
                {{ plan.title }}
              </h4>
              <div class="membership-price-row">
                <span class="price-label">Price</span>
                <span class="price-value">{{ plan.price }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="payment-meta" v-if="signupData">
          <p>{{ signupData.email }}</p>
        </div>

        <div class="form-message" v-if="message">
          <div :class="messageType === 'success' ? 'inline-success' : 'inline-error'">
            {{ message }}
          </div>
        </div>

        <div class="payment-actions">
          <button type="button" class="back-btn" :disabled="isLoading" @click="goBack">
            Back
          </button>
          <button
            type="button"
            class="submit-btn"
            :disabled="isLoading"
            @click="startPayment"
          >
            <span v-if="!isLoading">Pay now</span>
            <span v-else>Redirecting...</span>
            <div class="cardbottom-shadow">
              <img src="/images/cardshadow.png" alt="">
            </div>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios';
import { lockBodyScrollInline, releaseBodyScrollLock } from '@/views/lib/bodyScrollLock';
import { getPlanById, savePendingSignup } from '@/views/lib/pendingSignup';

export default {
  name: 'PaymentModal',
  props: {
    signupData: {
      type: Object,
      required: true,
    },
    membership: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      message: '',
      messageType: '',
    };
  },
  computed: {
    plan() {
      return getPlanById(this.membership);
    },
  },
  mounted() {
    lockBodyScrollInline();
  },
  beforeDestroy() {
    releaseBodyScrollLock();
  },
  methods: {
    goBack() {
      releaseBodyScrollLock();
      this.$emit('back');
    },
    closeModal() {
      if (this.isLoading) return;
      releaseBodyScrollLock();
      this.$emit('close');
    },
    async startPayment() {
      if (this.isLoading) return;

      this.message = '';
      this.isLoading = true;

      // const baseUrl = 'http://127.0.0.1:8000/api';
      // const baseUrl = 'https://dev.imsynapse.com/api'
      // const baseUrl = 'https://admin.imsynapse.com/api'
      const baseUrl = 'https://admin.uksynapse.com/api'

      try {
        await savePendingSignup({
          form: this.signupData,
          membership: this.membership,
        });

        const successUrl = `${window.location.origin}/?polar=success&checkout_id={CHECKOUT_ID}`;

        const { data } = await axios.post(`${baseUrl}/polar/checkout`, {
          membership: this.membership,
          email: this.signupData.email,
          username: this.signupData.username,
          success_url: successUrl,
        });

        if (!data || !data.url) {
          throw new Error('Checkout URL missing from server response.');
        }

        window.location.href = data.url;
      } catch (error) {
        const errors = error.response?.data?.errors;
        let detail = '';
        if (errors && typeof errors === 'object') {
          const first = Object.values(errors)[0];
          detail = Array.isArray(first) ? first[0] : String(first || '');
        }

        this.message =
          detail ||
          error.response?.data?.message ||
          error.message ||
          'Unable to start payment. Please try again.';
        this.messageType = 'error';
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.4s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-active .modal-content,
.modal-leave-active .modal-content {
  transition: transform 0.4s ease;
}

.modal-enter-from .modal-content {
  transform: translateY(-40px);
}

.modal-leave-to .modal-content {
  transform: translateY(-40px);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffffffc7;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  padding: 20px 12px;
  box-sizing: border-box;
}

.modal-content {
  background: white;
  padding: 40px 40px 0;
  border-radius: 50px;
  position: relative;
  width: 100%;
  max-width: 380px;
  max-height: 92vh;
  overflow-y: auto;
  will-change: transform;
  transform: translateY(0);
  box-shadow: 0 0 23.34px #000000BF;
}

.payment-head {
  padding-bottom: 12px !important;
  text-align: center;
}

.payment-subtitle {
  text-align: center;
  color: #6D6E71;
  font-size: 13px;
  font-weight: 300;
  margin: 0 0 22px;
}

.selected-plan-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.membership-pill {
  width: 100%;
  max-width: 260px;
  border-radius: 16px;
  padding: 10px 12px 8px;
  box-sizing: border-box;
}

.tone-questions {
  background: #1a90ff;
  border: 1px solid #0276ba;
}

.tone-notes {
  background: #fbad18;
  border: 1px solid #e69500;
}

.tone-mocks {
  background: #ed2724;
  border: 1px solid #c41a1f;
}

.tone-all {
  background: #20b14b;
  border: 1px solid #178a39;
}

.membership-pill-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.membership-pill h4 {
  margin: 0;
  font-size: 18px;
  color: #fff;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  font-family: Helvetica, sans-serif;
  font-weight: 700;
}

.membership-pill h4 img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.membership-price-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.price-label {
  color: rgba(255, 255, 255, 0.9);
  font-size: 12px;
}

.price-value {
  color: #fff;
  font-size: 15px;
  font-weight: 700;
}

.payment-meta {
  text-align: center;
  margin-bottom: 12px;
}

.payment-meta p {
  margin: 0;
  color: #6D6E71;
  font-size: 13px;
}

.payment-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 10px 0 28px;
}

.back-btn {
  background: transparent;
  color: #8698A2;
  border: 2px solid #8698A2;
  border-radius: 35px;
  cursor: pointer;
  width: 100px;
  height: 29.60px;
  font-weight: bold;
  font-size: 14px;
  transition: all 0.6s ease;
}

.back-btn:hover:not(:disabled) {
  background: #8698a278;
  color: #fff;
}

.back-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.submit-btn {
  background-color: #9DED6C;
  color: #231F20;
  padding: 5px 0;
  border: 1px solid #00a14b75;
  border-radius: 35px;
  cursor: pointer;
  width: 111.84px;
  transition: all 0.6s ease;
  font-weight: bold;
  font-size: 14px;
  height: 29.60px;
  position: relative;
}

.submit-btn:hover:not(:disabled) {
  background: #20B14B;
  color: #fff;
}

.submit-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.submit-btn .cardbottom-shadow img {
  left: 50%;
  transform: translate(-50%);
  width: 200px;
}

.form-message {
  margin-bottom: 8px;
  padding: 0 8px;
}

.inline-error,
.inline-success {
  padding: 8px 10px;
  border-radius: 10px;
  font-size: 12px;
  text-align: center;
}

.inline-error {
  background: #ffebee;
  color: #e53935;
}

.inline-success {
  background: #e8f5e9;
  color: #2e7d32;
}
</style>
